import { render, staticRenderFns } from "./TopicPicker.vue?vue&type=template&id=46162782&"
import script from "./TopicPicker.vue?vue&type=script&lang=js&"
export * from "./TopicPicker.vue?vue&type=script&lang=js&"
import style0 from "./TopicPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports